/**
 * Shared types for Outbound Emails
 *
 * These constants and types are shared between frontend, backend, and RPC contracts
 * to ensure type consistency across the codebase.
 */

/**
 * Outbound email status values
 * - pending: Email is queued to be sent
 * - draft: Email is saved for review before sending
 * - sent: Email was successfully sent
 * - failed: Email sending failed
 * - bounced: Email was rejected by recipient server
 */
export const OUTBOUND_EMAIL_STATUSES = [
  "pending",
  "draft",
  "sent",
  "failed",
  "bounced",
] as const;

export type OutboundEmailStatus = (typeof OUTBOUND_EMAIL_STATUSES)[number];
